var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleSystemIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\x8E\xD0\xA0\xC2\xBB\xD0\xA0\xD1\x95\xD0\xA0\xE2\x84\x96_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.485 47.5302C9.18499 44.6302 1.995 35.1302 1.995 24.4202C1.995 22.1202 2.315 19.8502 2.965 17.6602L4.925 18.2402C4.335 20.2402 4.045 22.3202 4.045 24.4202C4.045 34.2202 10.625 42.9102 20.045 45.5602L19.495 47.5302H19.485Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.505 47.5302L31.955 45.5602C41.375 42.9102 47.955 34.2202 47.955 24.4202C47.955 22.3202 47.655 20.2402 47.075 18.2402L49.035 17.6602C49.675 19.8502 50.005 22.1202 50.005 24.4202C50.005 35.1302 42.815 44.6302 32.515 47.5302H32.505Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.1849 8.20992L9.80493 6.69992C14.2349 2.64992 19.9849 0.419922 25.9949 0.419922C32.0049 0.419922 37.6849 2.62992 42.1149 6.63992L40.7449 8.15992C36.7049 4.48992 31.4649 2.47992 26.0049 2.47992C20.5449 2.47992 15.2549 4.51992 11.1949 8.22992L11.1849 8.20992Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.995 51.5799C23.465 51.5799 21.405 49.5199 21.405 46.9899C21.405 44.4599 23.465 42.3999 25.995 42.3999C28.525 42.3999 30.585 44.4599 30.585 46.9899C30.585 49.5199 28.525 51.5799 25.995 51.5799ZM25.995 44.4499C24.595 44.4499 23.455 45.5899 23.455 46.9899C23.455 48.3899 24.595 49.5299 25.995 49.5299C27.395 49.5299 28.535 48.3899 28.535 46.9899C28.535 45.5899 27.395 44.4499 25.995 44.4499Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.585 16.8797C4.055 16.8797 1.995 14.8297 1.995 12.2897C1.995 9.74971 4.055 7.69971 6.585 7.69971C9.115 7.69971 11.175 9.75971 11.175 12.2897C11.175 14.8197 9.115 16.8797 6.585 16.8797ZM6.585 9.74971C5.185 9.74971 4.045 10.8897 4.045 12.2897C4.045 13.6897 5.185 14.8297 6.585 14.8297C7.985 14.8297 9.125 13.6897 9.125 12.2897C9.125 10.8897 7.985 9.74971 6.585 9.74971Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.4049 16.8797C42.8749 16.8797 40.8149 14.8197 40.8149 12.2897C40.8149 9.75971 42.8749 7.69971 45.4049 7.69971C47.9349 7.69971 49.9949 9.75971 49.9949 12.2897C49.9949 14.8197 47.9349 16.8797 45.4049 16.8797ZM45.4049 9.74971C44.0049 9.74971 42.8649 10.8897 42.8649 12.2897C42.8649 13.6897 44.0049 14.8297 45.4049 14.8297C46.8049 14.8297 47.9449 13.6897 47.9449 12.2897C47.9449 10.8897 46.8049 9.74971 45.4049 9.74971Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.995 25.67C21.735 25.67 18.275 22.21 18.275 17.95C18.275 13.69 21.735 10.23 25.995 10.23C30.255 10.23 33.715 13.69 33.715 17.95C33.715 22.21 30.255 25.67 25.995 25.67ZM25.995 12.27C22.865 12.27 20.315 14.82 20.315 17.95C20.315 21.08 22.865 23.63 25.995 23.63C29.125 23.63 31.675 21.08 31.675 17.95C31.675 14.82 29.125 12.27 25.995 12.27Z",
    fill: "#093640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.905 37.49H34.855V34.93C34.855 32.35 32.755 30.26 30.185 30.26H21.805C19.235 30.26 17.135 32.35 17.135 34.93V37.49H15.085V34.93C15.085 31.23 18.095 28.21 21.805 28.21H30.185C33.885 28.21 36.905 31.22 36.905 34.93V37.49Z",
    fill: "#093640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleSystemIcon);
export default __webpack_public_path__ + "static/media/roleSystem_icon.944de851c36c85ca3dc7697b7c29cb32.svg";
export { ForwardRef as ReactComponent };